import { Observable, Subscription } from "rxjs";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { Store } from "@ngrx/store";
import {
  LobbyEntryDetail,
  LobbyInteraction,
} from "../shared/models/lobby-entry-detail";
import {
  getCurrentInteractionServiceProvided,
  getImpersonatedByCode,
  getImpersonatedByName,
  getIsImpersonateAssist,
  getLobbyEntryDetail,
  getServiceFilterValue,
  getShowCheckListPopUp,
  getShowCheckListPopUpForRequestedServices,
  getWrapUpCommenr,
  State,
} from "./state";
import { getWrapUpServices } from "../lobby-check-in/state";
import * as LobbyWrapUpPageActions from "./state/actions/wrap-up-page.actions";
import {
  CheckListPopUpDetail,
  CheckListPopUpDetailForRequestedServices,
} from "./shared/models/checklist-popup-detail";
import { ToastService } from "src/app/shared/services/toast.service";
import {
  getACLicenseStatus,
  getLobbyShowCategory,
  getSystemConfigurations,
  getUrlCodeForCurrentTenant,
} from "src/app/state";
import { SystemConfigValue } from "src/app/admin/system-configuration/shared/models/system-config-value";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from "@angular/forms";
import { GenericValidator } from "src/app/shared/validators/generic-validator";
import { LobbyServiceWithCategory } from "../shared/models/lobby-service";
import { AppConfigurations } from "src/app/shared/models/appConfiguration.model";
import { AppInitService } from "src/app/app-init.service";
import { CdTimerComponent } from "angular-cd-timer";
import { TranslationLoaderFacade } from "src/app/admin/localization/translation-loader.facade";
import { TranslateService } from "@ngx-translate/core";
import { getLoggedInUserInfo } from "src/app/state";
import { ConfigurationGroup } from "src/app/shared/enums/configurationGroup.enum";
import { SystemConfigurationName } from "src/app/shared/enums/systemConfigurationName.enum";

@Component({
  selector: "app-lobby-wrap-up",
  templateUrl: "./lobby-wrap-up.component.html",
  styleUrls: ["./lobby-wrap-up.component.scss"],
})
export class LobbyWrapUpComponent implements OnInit, OnDestroy {
  NULL_LOBBY_ENTRY_DETAIL_ERROR: string = `[${LobbyWrapUpComponent.name}]: Unexpected code path reached. 'lobbyEntryDetail' was not expected to be null.`;

  private acWidgetUrl: string = "";
  private urlCode: string = "";
  lobbyEntryDetail?: LobbyEntryDetail;
  previousInteractions?: LobbyInteraction[];
  currentInteraction?: LobbyInteraction;
  currentInterationTime: number = 0;
  wrapUpComment?: string;
  wrapUpCommentRequiredError?: string;
  searchFilter: string = "";
  checkListPopUpDetail?: CheckListPopUpDetail;
  checkListPopUpDetailForRequestedService?: CheckListPopUpDetailForRequestedServices;
  lobbyServices$?: LobbyServiceWithCategory[];
  lobbyServices: any[] = [];
  lobbyWrapUpConfiguration: any;
  isCheckListAvailableForRequestedService: boolean = false;
  currentlyEditingReference?: number | null = null;
  private appConfig?: AppConfigurations;
  private wrapUpDialogOpened: boolean = false;
  isACLicenseEnabled$?: Observable<boolean>;
  public isImpersonateAssist: boolean = false;
  public impersonateByName: string | null = null;
  public titleString: string = "";
  showLobbyCateogory: boolean = false;
  wrapUpSubscriptions = new Subscription();
  sortdedAscending: boolean = false;
  sorted: boolean = false;
  displayMessage: { [key: string]: string } = {};
  private validationMessages!: { [key: string]: { [key: string]: string } };
  private genericValidator!: GenericValidator;
  public impersonateByCode: string | null = null;
  public userCode: string = "";
  public isAllowWidgetAppointmentsThroughPortalEnabled: boolean = false;

  public lobbyWrapUpForm: FormGroup = new FormGroup({
    wrapUpCommentFormControl: new FormControl("", []),
  });

  constructor(
    private store: Store<State>,
    private toastService: ToastService,
    private fb: FormBuilder,
    private appInitService: AppInitService,
    private translationLoaderFacade: TranslationLoaderFacade,
    private translateService: TranslateService
  ) {}

  @ViewChild("lobbyWrapUpModal") public modal: any;
  @ViewChildren("interactionTimer", {})
  interactionTimer?: QueryList<CdTimerComponent>;
  @Input() public signInLocationId: number = 0;
  @Input() set dialogOpened(value: boolean) {
    if (value) {
      this.lobbyWrapUpForm.reset();
      this.store.dispatch(
        LobbyWrapUpPageActions.showWrapUp({
          isImpersonateAssist: this.isImpersonateAssist,
        })
      );
      this.setCurrentInteractionDuration();
    }
    this.wrapUpDialogOpened = value;
  }
  get dialogOpened(): boolean {
    return this.wrapUpDialogOpened;
  }
  @Output() public cancelled = new EventEmitter();
  @Output() public dialogOpenedChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  ngAfterViewInit() {}
  ngOnInit() {
    this.isACLicenseEnabled$ = this.store.select(getACLicenseStatus);
    const appConfigSub = this.appInitService.getAppConfiguration$().subscribe({
      next: (config) => {
        this._onReceiveAppConfig(config);
      },
    });
    this.wrapUpSubscriptions.add(
      this.store.select(getLobbyShowCategory).subscribe((lobbyCategory) => {
        this.showLobbyCateogory = lobbyCategory;
      })
    );
    this.wrapUpSubscriptions.add(
      this.store.select(getSystemConfigurations).subscribe((configurations) => {
        const lobbyConfigurations = configurations.filter(
          (c) => c.configurationGroup === "LobbySettings"
        );
        if (lobbyConfigurations.length > 0) {
          this.lobbyWrapUpConfiguration = {
            EnableAccountNumber: this.readCastedValue(
              lobbyConfigurations.find(
                (ac) => ac.configurationName === "EnableAccountNumber"
              )
            ),
            CommentsRequired: this.readCastedValue(
              lobbyConfigurations.find(
                (ac) => ac.configurationName === "CommentsRequired"
              )
            ),
            ShowCategoriesInLobby: this.readCastedValue(
              lobbyConfigurations.find(
                (ac) => ac.configurationName === "ShowCategories"
              )
            ),
            EnableReferenceNumber: this.readCastedValue(
              lobbyConfigurations.find(
                (ac) => ac.configurationName === "EnableReferenceNumber"
              )
            ),
            CustomFieldText: this.readCastedValue(
              lobbyConfigurations.find(
                (x) => x.configurationName == "CustomFieldText"
              )
            ),
            AccountNumberDisplayText: this.readCastedValue(
              lobbyConfigurations.find(
                (x) => x.configurationName == "AccountNumberDisplayText"
              )
            ),
          };

          // Always update validators based on CommentsRequired
          const commentControl = this.lobbyWrapUpForm.get(
            "wrapUpCommentFormControl"
          );
          if (this.lobbyWrapUpConfiguration.CommentsRequired) {
            commentControl?.setValidators([Validators.required]);
          } else {
            commentControl?.clearValidators();
          }
          commentControl?.updateValueAndValidity();

          this.store
            .select(
              getWrapUpServices(
                this.lobbyWrapUpConfiguration.ShowCategoriesInLobby
              )
            )
            .subscribe((services) => {
              this.lobbyServices = services;
              if (this.sorted) {
                this.sortServicesClick();
              }
            });
        }

        const appointmentConfigurations = configurations.filter(
          (c) => c.configurationGroup === ConfigurationGroup.AppointmentSettings
        );
        if (appointmentConfigurations.length > 0) {
          const allowWidgetAppointmentsThroughPortal = this.readCastedValue(
            appointmentConfigurations.find(
              (ac) =>
                ac.configurationName ===
                SystemConfigurationName.AllowWidgetAppointmentThrough
            )
          );
          if (typeof allowWidgetAppointmentsThroughPortal == "boolean") {
            this.isAllowWidgetAppointmentsThroughPortalEnabled =
              allowWidgetAppointmentsThroughPortal;
          }
        }
      })
    );

    const lobbyEntryDetailSubscription = this.store
      .select(getLobbyEntryDetail)
      .subscribe((lobbyEntry) => {
        this.lobbyEntryDetail = JSON.parse(JSON.stringify(lobbyEntry));
        if (lobbyEntry !== null && this.lobbyEntryDetail != null) {
          this.previousInteractions = lobbyEntry.lobbyInteractions.filter(
            (interaction) => interaction.completedTime !== null
          );
          this.currentInteraction =
            this.lobbyEntryDetail.lobbyInteractions.find(
              (interaction) => interaction.completedTime === null
            );
          this.isCheckListAvailableForRequestedService =
            lobbyEntry.requestedServices.filter((rs) => rs.isCheckListAvailable)
              .length > 0;
          if (
            lobbyEntry.lobbyComments != null &&
            lobbyEntry.lobbyComments.length > 0
          ) {
            this.store.dispatch(
              LobbyWrapUpPageActions.setWrapUpComment({
                comment:
                  lobbyEntry.lobbyComments[lobbyEntry.lobbyComments.length - 1]
                    .comment,
              })
            );
          }
          this.setCurrentInteractionDuration();
          this.interactionTimer?.forEach((element, index) => {
            if (
              this.lobbyEntryDetail != null &&
              this.currentInteraction != null &&
              this.lobbyEntryDetail.lobbyInteractions.length > 0
            ) {
              const currentDate = new Date();
              const dateSent = new Date(this.currentInteraction.assistedTime);
              this.currentInterationTime =
                Math.floor(
                  new Date(
                    currentDate.getTime() +
                      currentDate.getTimezoneOffset() * 60000
                  ).getTime() - dateSent.getTime()
                ) / 1000;
              element.startTime = this.currentInterationTime;
              element.start();
            }
          });

          if (!this.isImpersonateAssist) {
            this.titleString =
              "Wrap Up: " + lobbyEntry.firstName + " " + lobbyEntry.lastName;
          }
        } else {
          this.previousInteractions = [];
          this.currentInteraction = undefined;
          this.currentInterationTime = 0;
          this.isCheckListAvailableForRequestedService = false;
        }
      });

    const checkListPopUpSubscription = this.store
      .select(getShowCheckListPopUp)
      .subscribe((checkListDetail) => {
        this.checkListPopUpDetail = JSON.parse(JSON.stringify(checkListDetail));
        if (this.checkListPopUpDetail) {
          if (
            this.checkListPopUpDetail.serviceDetail.checkListItems.length > 0
          ) {
            for (
              let i = 0;
              i <=
              this.checkListPopUpDetail.serviceDetail.checkListItems.length;
              i++
            ) {
              if (
                this.checkListPopUpDetail.serviceDetail.checkListItems[i] &&
                this.checkListPopUpDetail.serviceDetail.checkListItems[i].link
              ) {
                try {
                  this.checkListPopUpDetail.serviceDetail.checkListItems[
                    i
                  ].link = decodeURIComponent(
                    this.checkListPopUpDetail.serviceDetail.checkListItems[i]
                      .link
                  );
                } catch (e) {
                  console.error(e);
                }
              }
            }
          }
        }
      });
    const userInfoSubscription = this.store
      .select(getLoggedInUserInfo)
      .subscribe((userInfo) => {
        if (userInfo != null) {
          this.userCode = userInfo.userCode;
        }
      });
    const checkListPopUpForRequestedServiceSubscription = this.store
      .select(getShowCheckListPopUpForRequestedServices)
      .subscribe((checkListDetails) => {
        this.checkListPopUpDetailForRequestedService = JSON.parse(
          JSON.stringify(checkListDetails)
        );
        if (
          this.checkListPopUpDetailForRequestedService &&
          this.checkListPopUpDetailForRequestedService.serviceDetails.length > 0
        ) {
          this.checkListPopUpDetailForRequestedService.serviceDetails.forEach(
            (serviceDetail) => {
              if (serviceDetail.checkListItems.length > 0) {
                for (let i = 0; i <= serviceDetail.checkListItems.length; i++) {
                  if (
                    serviceDetail.checkListItems[i] &&
                    serviceDetail.checkListItems[i].link
                  ) {
                    try {
                      serviceDetail.checkListItems[i].link = decodeURIComponent(
                        serviceDetail.checkListItems[i].link
                      );
                    } catch (e) {
                      console.error(e);
                    }
                  }
                }
              }
            }
          );
        }
      });

    const wrapUpCommentSubscription = this.store
      .select(getWrapUpCommenr)
      .subscribe((comment) => {
        this.wrapUpComment = comment;
        if (comment) {
          this.wrapUpCommentRequiredError = undefined;
        }
      });

    const searchFilterSubscription = this.store
      .select(getServiceFilterValue)
      .subscribe((searchFilter) => {
        this.searchFilter = searchFilter;
      });
    const impersonateFlagSubscription = this.store
      .select(getIsImpersonateAssist)
      .subscribe((flag) => {
        this.isImpersonateAssist = flag;
      });
    const impersonateNameSubscription = this.store
      .select(getImpersonatedByName)
      .subscribe((name) => {
        if (this.isImpersonateAssist) {
          this.titleString = "Wrap Up � Assisting as " + name;
          this.impersonateByName = name;
        } else if (this.lobbyEntryDetail != null) {
          this.titleString =
            "Wrap Up: " +
            this.lobbyEntryDetail.firstName +
            " " +
            this.lobbyEntryDetail.lastName;
        }
      });
    const impersonateCodeSubscription = this.store
      .select(getImpersonatedByCode)
      .subscribe((code) => {
        if (this.isImpersonateAssist) {
          this.impersonateByCode = code;
        } else {
          this.impersonateByCode = null;
        }
      });
    const validationSubscription = this.lobbyWrapUpForm.valueChanges.subscribe(
      () => {
        this.validationMessages = {
          wrapUpCommentFormControl: {
            required: this.translateService.instant(
              "_Lobby_Comment_Required_Ts_Text_"
            ),
          },
        };

        this.genericValidator = new GenericValidator(this.validationMessages);
        this.displayMessage = this.genericValidator.processMessages(
          this.lobbyWrapUpForm
        );
      }
    );
    const urlCodeSubs = this.store
      .select(getUrlCodeForCurrentTenant)
      .subscribe((urlcode) => (this.urlCode = urlcode));
    const currentInteractionServiceProvidedSubscription = this.store
      .select(getCurrentInteractionServiceProvided)
      .subscribe((serviceProvided) => {
        var serviceProvidedArr = JSON.parse(JSON.stringify(serviceProvided));

        if (this.lobbyEntryDetail != null) {
          let lobbyInteraction = this.lobbyEntryDetail.lobbyInteractions.find(
            (interaction) => interaction.completedTime === null
          );
          if (lobbyInteraction != null)
            lobbyInteraction.lobbyServiceProvided = serviceProvidedArr;
        }
      });

    this.wrapUpSubscriptions.add(validationSubscription);
    this.wrapUpSubscriptions.add(lobbyEntryDetailSubscription);
    this.wrapUpSubscriptions.add(checkListPopUpSubscription);
    this.wrapUpSubscriptions.add(checkListPopUpForRequestedServiceSubscription);
    this.wrapUpSubscriptions.add(wrapUpCommentSubscription);
    this.wrapUpSubscriptions.add(searchFilterSubscription);
    this.wrapUpSubscriptions.add(urlCodeSubs);
    this.wrapUpSubscriptions.add(appConfigSub);
    this.wrapUpSubscriptions.add(impersonateNameSubscription);
    this.wrapUpSubscriptions.add(impersonateFlagSubscription);
    this.wrapUpSubscriptions.add(currentInteractionServiceProvidedSubscription);
    this.wrapUpSubscriptions.add(impersonateCodeSubscription);
    this.wrapUpSubscriptions.add(userInfoSubscription);
  }
  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.acWidgetUrl = this.appConfig.ac.appointmentWidegetUrl;
  }
  public goToACWebWidgetFollowUp() {
    if (this.lobbyEntryDetail != null) {
      const cby = this.isImpersonateAssist
        ? this.impersonateByCode
        : this.userCode;
      const acWidgetFullUrl = `${this.acWidgetUrl}?urlCode=${this.urlCode}&loc=${this.lobbyEntryDetail.locationCode}&cfn=${this.lobbyEntryDetail.firstName}&cln=${this.lobbyEntryDetail.lastName}&cph=${this.lobbyEntryDetail.phoneNumber}&cem=${this.lobbyEntryDetail.emailAddress}&cby=${cby}`;
      window.open(acWidgetFullUrl, "_blank");
    } else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
  }

  ngOnDestroy(): void {
    this.wrapUpSubscriptions.unsubscribe();
  }

  public close() {
    this.lobbyWrapUpForm.reset();
    this.store.dispatch(LobbyWrapUpPageActions.hideWrapUp());
    this.sorted = false;
    this.sortdedAscending = false;
    this.cancelled.emit();
  }

  viewCheckListForRequestedService() {
    if (this.lobbyEntryDetail != null) {
      const serviceIds: number[] = this.lobbyEntryDetail.requestedServices
        .filter((rs) => rs.isCheckListAvailable)
        .map((rs) => rs.id);
      this.store.dispatch(
        LobbyWrapUpPageActions.getCheckListForRequestedService({ serviceIds })
      );
    } else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
  }

  provideService(serviceId: number, isCheckListAvailable: boolean) {
    if (isCheckListAvailable) {
      this.store.dispatch(LobbyWrapUpPageActions.getCheckList({ serviceId }));
    } else {
      if (this.lobbyEntryDetail != null)
        this.store.dispatch(
          LobbyWrapUpPageActions.provideService({
            lobbyEntryId: this.lobbyEntryDetail.lobbyEntryId,
            serviceId,
          })
        );
      else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
    }
  }

  updateProvidedServiceReference(serviceProvidedId: number, reference: string) {
    this.currentlyEditingReference = null;
    if (this.lobbyEntryDetail != null) {
      this.store.dispatch(
        LobbyWrapUpPageActions.updateProvidedServiceReference({
          lobbyEntryId: this.lobbyEntryDetail.lobbyEntryId,
          serviceProvidedId,
          reference: reference !== null ? reference : "",
        })
      );
    } else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
  }

  removeProvidedService(serviceProvidedId: number) {
    this.currentlyEditingReference = null;
    if (this.lobbyEntryDetail != null) {
      this.store.dispatch(
        LobbyWrapUpPageActions.removeProvidedService({
          lobbyEntryId: this.lobbyEntryDetail.lobbyEntryId,
          serviceProvidedId,
        })
      );
    } else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
  }

  wrapUpAssist() {
    if (
      this.lobbyWrapUpConfiguration.CommentsRequired &&
      this.wrapUpComment == null
    ) {
      this.wrapUpCommentRequiredError = "Comment Required";
    } else {
      var signedInLocationId = 0;
      if (this.isImpersonateAssist && this.lobbyEntryDetail != null) {
        signedInLocationId = this.lobbyEntryDetail.locationId;
      } else {
        signedInLocationId = this.signInLocationId;
      }

      if (this.lobbyEntryDetail != null) {
        this.store.dispatch(
          LobbyWrapUpPageActions.wrapUpAssist({
            wrapUpData: {
              lobbyEntryId: this.lobbyEntryDetail.lobbyEntryId,
              comment: this.wrapUpComment ?? "",
              signedInLocationId: signedInLocationId,
            },
          })
        );
      } else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
    }
  }

  returnVisitorToLobby() {
    var signedInLocationId = 0;

    if (this.isImpersonateAssist && this.lobbyEntryDetail != null) {
      signedInLocationId = this.lobbyEntryDetail.locationId;
    } else {
      signedInLocationId = this.signInLocationId;
    }

    if (this.lobbyEntryDetail != null)
      this.store.dispatch(
        LobbyWrapUpPageActions.backToLobby({
          lobbyEntryId: this.lobbyEntryDetail.lobbyEntryId,
          assistingUserLocationId: signedInLocationId,
          isImpersonateAssist: this.isImpersonateAssist,
          comment: this.wrapUpComment ?? "",
        })
      );
    else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
  }

  cancelCheckListDialog() {
    this.store.dispatch(LobbyWrapUpPageActions.closeCheckList());
  }

  cancelCheckListForRequestedServiceDialog() {
    this.store.dispatch(
      LobbyWrapUpPageActions.closeRequestedServiceCheckList()
    );
  }

  completeCheckListDialog(serviceId: number) {
    if (this.lobbyEntryDetail != null)
      this.store.dispatch(
        LobbyWrapUpPageActions.provideService({
          lobbyEntryId: this.lobbyEntryDetail.lobbyEntryId,
          serviceId,
        })
      );
    else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
    this.store.dispatch(LobbyWrapUpPageActions.closeCheckList());
  }

  getAllCheckListItemChecked(): boolean {
    if (this.checkListPopUpDetail != null)
      return this.checkListPopUpDetail?.serviceDetail.checkListItems.every(
        (item) => item.checked
      );
    else
      throw new Error(
        `[${LobbyWrapUpComponent.name}]: Unexpected code path reached. 'checkListPopUpDetail' was not expected to be null.`
      );
  }

  updateWrapUpText(event: string) {
    this.store.dispatch(
      LobbyWrapUpPageActions.setWrapUpComment({ comment: event })
    );
  }

  clearSearchFilter() {
    this.searchFilter = "";
    this.store.dispatch(
      LobbyWrapUpPageActions.setSearchFilter({ searchValue: "" })
    );
  }

  setSearchFilter() {
    this.store.dispatch(
      LobbyWrapUpPageActions.setSearchFilter({ searchValue: this.searchFilter })
    );
  }

  serviceFilterKeyPress(event: any) {
    if (event.which === 13 || this.searchFilter === "") {
      this.store.dispatch(
        LobbyWrapUpPageActions.setSearchFilter({
          searchValue: this.searchFilter,
        })
      );
    }
  }

  serviceFilterChanged(event: string) {
    if (event === "") {
      this.store.dispatch(
        LobbyWrapUpPageActions.setSearchFilter({ searchValue: "" })
      );
    }
  }

  showEditReference(interactionId: number, serviceProvidedId: number) {
    this.currentlyEditingReference = serviceProvidedId;
    this.store.dispatch(
      LobbyWrapUpPageActions.showEditServiceReference({
        lobbyEntryDetail: this.setShowEditReference(
          interactionId,
          serviceProvidedId
        ),
      })
    );
  }

  closeEditReference(interactionId: number, serviceProvidedId: number) {
    this.currentlyEditingReference = null;
    this.setReference(interactionId, serviceProvidedId, {
      value: "",
    } as HTMLInputElement);
    this.store.dispatch(
      LobbyWrapUpPageActions.showEditServiceReference({
        lobbyEntryDetail: this.setShowEditReference(
          interactionId,
          serviceProvidedId
        ),
      })
    );
  }

  setReference(
    interactionId: number,
    serviceProvidedId: number,
    reference: EventTarget | HTMLInputElement | null
  ) {
    this.store.dispatch(
      LobbyWrapUpPageActions.showEditServiceReference({
        lobbyEntryDetail: this.setEditReference(
          interactionId,
          serviceProvidedId,
          (reference as HTMLInputElement).value
        ),
      })
    );
  }

  restrictSpecialCharacters(event: KeyboardEvent) {
    const invalidChars = ["<", ">", "&"];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  restrictPasteSpecialCharacters(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData("text") || "";
    if (/[<>&]/.test(pastedText)) {
      event.preventDefault();
    }
  }

  copyInputMessage() {
    this.toastService.showSuccess("_Lobby_Lobby_Id_Copied_Ts_Text_");
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  validateSpecialCharacters(event: any) {
    if (event.which === 60 || event.which === 62 || event.which === 38) {
      event.preventDefault();
    }
  }

  getInteractionDuration(interaction: LobbyInteraction) {
    const endTime = new Date(interaction.completedTime!);
    const startTime = new Date(interaction.assistedTime);
    return Math.floor(endTime.getTime() - startTime.getTime()) / 1000;
  }

  private setCurrentInteractionDuration() {
    if (
      this.lobbyEntryDetail != null &&
      this.currentInteraction != null &&
      this.lobbyEntryDetail.lobbyInteractions.length > 0
    ) {
      const currentDate = new Date();
      const dateSent = new Date(this.currentInteraction.assistedTime);
      this.currentInterationTime =
        Math.floor(
          new Date(
            currentDate.getTime() + currentDate.getTimezoneOffset() * 60000
          ).getTime() - dateSent.getTime()
        ) / 1000;
    }
  }

  private setShowEditReference(interaction: number, serviceProvidedId: number) {
    const interactionDetail = this.lobbyEntryDetail?.lobbyInteractions.find(
      (i) => i.interactionId === interaction
    );
    if (interactionDetail != null) {
      const serviceProvidedDetail = interactionDetail.lobbyServiceProvided.find(
        (sp) => sp.serviceProvidedId === serviceProvidedId
      );
      if (serviceProvidedDetail) {
        serviceProvidedDetail.showEditReference =
          serviceProvidedDetail.showEditReference === undefined
            ? true
            : !serviceProvidedDetail.showEditReference;
      }
    }
    if (this.lobbyEntryDetail != null) return this.lobbyEntryDetail;
    else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
  }

  private setEditReference(
    interaction: number,
    serviceProvidedId: number,
    reference: string
  ) {
    const interactionDetail = this.lobbyEntryDetail?.lobbyInteractions.find(
      (i) => i.interactionId === interaction
    );
    if (interactionDetail != null) {
      const serviceProvidedDetail = interactionDetail.lobbyServiceProvided.find(
        (sp) => sp.serviceProvidedId === serviceProvidedId
      );
      if (serviceProvidedDetail!.showEditReference) {
        serviceProvidedDetail!.refferenceNumber = reference;
      }
    }
    if (this.lobbyEntryDetail != null) return this.lobbyEntryDetail;
    else throw new Error(this.NULL_LOBBY_ENTRY_DETAIL_ERROR);
  }

  private readCastedValue(systemConfigValue?: SystemConfigValue): any {
    if (systemConfigValue) {
      switch (systemConfigValue.dataType) {
        case "int":
          return parseInt(systemConfigValue.value, undefined);
        case "bool":
          return systemConfigValue.value === "1";
        default:
          return systemConfigValue.value;
      }
    }
  }
  blur(): void {
    this.displayMessage = this.genericValidator.processMessages(
      this.lobbyWrapUpForm
    );
  }
  public sortServices() {
    this.sorted = true;
    this.sortdedAscending = !this.sortdedAscending;
    this.lobbyServices.sort((item1: any, item2: any) =>
      this.compare(item1, item2)
    );
  }

  public sortServicesClick() {
    this.lobbyServices.sort((item1: any, item2: any) =>
      this.compare(item1, item2)
    );
  }

  compare(item1: any, item2: any): number {
    let compValue = 0;

    if (!this.lobbyWrapUpConfiguration.ShowCategoriesInLobby) {
      compValue = item1.service.name.localeCompare(item2.service.name, "en", {
        sensitivity: "base",
      });
    } else {
      compValue = item1.catName.localeCompare(item2.catName, "en", {
        sensitivity: "base",
      });
    }
    if (!this.sortdedAscending) {
      compValue = compValue * -1;
    }
    return compValue;
  }
}
